import { ConfirmationDrawer } from "./ConfirmationDrawer";
/* eslint-disable react/jsx-no-literals */

export const NavigationConfirmationDrawer = ({
  isVisible,
  onDismiss,
  onNavigateAnyways,
}: {
  isVisible: boolean;
  onDismiss: () => void;
  onNavigateAnyways: () => void;
}) => (
  <ConfirmationDrawer
    cancelText="Stay on Page"
    confirmText="Continue Without Saving"
    displayInformation={
      <div>
        <h2>Are you sure you want to leave without saving?</h2>
        <p>There are unsaved changes to the annotations.</p>
      </div>
    }
    isVisible={isVisible}
    onConfirm={onNavigateAnyways}
    onDismiss={onDismiss}
  />
);
